import {CommonMessages} from '../common.messages';

export const PanelEntitlementReportsMessages = {
    ExportExecutionReportFailed: {
        key: 'ExportExecutionReportFailed',
        message: 'Error while communication with the server. Unable to export report.'
    },
    ExportReportFailedNoSelectedProvider: {
        key: 'ExportReportFailedNoSelectedProvider',
        message: 'Provider not selected.'
    },
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while communication with the server. Unable to get report.'
    },
    GetPeriodsFailed: {
        key: 'GetPeriodsFailed',
        message: 'Error while communication with the server. Unable to get periods.'
    },
    ...CommonMessages
};
